// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__YOScu","title":"InfoRow_title__2Xjkp"};